// Translations for Waves Technology FZCO website
export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Products & Services",
      industries: "Industries",
      partners: "Partners",
      projects: "Projects",
      rfq: "Request RFQ",
      contact: "Contact",
    },
    common: {
      contactUs: "Contact Us",
      requestQuote: "Request a Quote",
      submitRfq: "Submit RFQ",
      contactTeam: "Contact Our Team",
      learnMore: "Learn More",
      readMore: "Read more",
      viewAll: "View all",
      seeAll: "See all",
      backHome: "Back to home",
      send: "Send Message",
      submit: "Submit",
      loading: "Sending…",
      success: "Submitted successfully. Our team will contact you shortly.",
      error: "Submission failed. Please try again.",
    },
    hero: {
      eyebrow: "Engineering · Procurement · Project Development",
      title: "A UAE-based engineering, Procurement, and Project Management partner for EPC projects.",
      subtitle:
        "Engineering, procurement and project development support for industrial, water treatment and infrastructure projects across the Middle East.",
      tagline: "Your Partner for Engineered Systems",
    },
    home: {
      overviewLabel: "Company Profile",
      overviewTitle: "A UAE-based engineering, procurement and project management partner for EPC projects.",
      overviewBody:
        "Waves Technology FZCO is registered under IFZA, Dubai, United Arab Emirates, providing engineering, procurement, technical consultancy and project development services for industrial and infrastructure sectors — with active engagement across Iraq, Egypt and the wider Middle East.",
      servicesLabel: "Core Capabilities",
      servicesTitle: "Engineering, procurement, vendor coordination and technical consultancy — across the project lifecycle.",
      industriesLabel: "Sectors We Support",
      industriesTitle: "Sectors We Serve",
      lifecycleLabel: "Project Lifecycle Support",
      lifecycleTitle: "A Trusted Partner",
      lifecycleBody:
        "Engaging us early helps de-risk technology selection, vendor coordination and budgeting, and gives clients a single technical interface across engineering, procurement and execution support phases.",
      partnersLabel: "Procurement & Coordination",
      partnersTitle: "Bridging buyers and international suppliers across mechanical, electrical and I&C scopes.",
      whyLabel: "Why Waves Technology",
      whyTitle: "Engineering depth. Regional knowledge. Flexible support model.",
      ctaTitle: "We will be Happy to Serve You",
      ctaBody: "Share your RFQ or talk to our team about your next project. We typically respond within one business day.",
    },
    services: {
      title: "Products & Services",
      subtitle:
        "Engineered systems, supply, consultancy and lifecycle support for industrial and infrastructure projects.",
    },
    industries: {
      title: "Industries We Serve",
      subtitle:
        "Engineered systems and procurement for the sectors that build and run the region's industrial economy.",
    },
    partners: {
      title: "Partners & Suppliers",
      subtitle:
        "A curated network of international manufacturers and technology providers — selected on track-record, certifications and lifecycle support.",
    },
    projects: {
      title: "Projects & References",
      subtitle:
        "A snapshot of engineering, procurement and project development work across Iraq, Egypt and the UAE. Detailed references available on request, subject to client confidentiality.",
    },
    rfq: {
      title: "Request a Quotation",
      subtitle:
        "Share your project requirements and attach drawings, datasheets or BOQs. Our engineering team will respond within one business day.",
      companyName: "Company name",
      contactPerson: "Contact person",
      email: "Business email",
      phone: "Phone (with country code)",
      country: "Country",
      category: "Product / Service category",
      description: "Project / RFQ description",
      attachment: "Attachment (PDF / XLSX / ZIP, max 10 MB)",
      attachmentHint: "Drag & drop a file here, or click to browse",
      categoryPlaceholder: "Select a category",
    },
    contact: {
      title: "Contact Waves Technology",
      subtitle:
        "Speak with our engineering and procurement team for technical evaluations, RFQs, and project development consulting.",
      formTitle: "Send us a message",
      name: "Name",
      company: "Company",
      email: "Email",
      phone: "Phone",
      country: "Country",
      subject: "Subject",
      message: "Message",
      officeTitle: "Head Office",
      officeAddress: "Dubai Silicon Oasis, DDP, Building A1, Dubai, UAE",
      emailLabel: "Email",
      websiteLabel: "Website",
      hoursLabel: "Hours",
      hours: "Sun – Thu · 09:00 – 18:00 (GST)",
    },
    about: {
      title: "About Waves Technology FZCO",
      subtitle:
        "An engineering company that brings together international manufacturers, engineered systems, and regional execution capability.",
      backgroundLabel: "Company Background",
      visionLabel: "Vision",
      missionLabel: "Mission",
      valuesLabel: "Values",
    },
    footer: {
      tagline: "Your Partner for Engineered Systems",
      quickLinks: "Quick Links",
      capabilities: "Capabilities",
      contact: "Contact",
      rights: "All rights reserved.",
      registered: "Registered under IFZA, Dubai, UAE",
    },
  },
  ar: {
    nav: {
      home: "الرئيسية",
      about: "عن الشركة",
      services: "المنتجات والخدمات",
      industries: "القطاعات",
      partners: "الشركاء",
      projects: "المشاريع",
      rfq: "طلب عرض سعر",
      contact: "تواصل معنا",
    },
    common: {
      contactUs: "تواصل معنا",
      requestQuote: "اطلب عرض سعر",
      submitRfq: "إرسال طلب عرض السعر",
      contactTeam: "تواصل مع فريقنا",
      learnMore: "اعرف المزيد",
      readMore: "اقرأ المزيد",
      viewAll: "عرض الكل",
      seeAll: "عرض الكل",
      backHome: "العودة للرئيسية",
      send: "إرسال الرسالة",
      submit: "إرسال",
      loading: "جاري الإرسال…",
      success: "تم الإرسال بنجاح. سيتواصل فريقنا معك قريباً.",
      error: "فشل الإرسال. يرجى المحاولة مرة أخرى.",
    },
    hero: {
      eyebrow: "هندسة · توريد · تطوير مشاريع",
      title: "شركة مقرها الإمارات للهندسة والتوريد وإدارة المشاريع، شريكٌ لمشاريع EPC.",
      subtitle:
        "دعم الهندسة والتوريد وتطوير المشاريع للقطاعات الصناعية ومعالجة المياه والبنية التحتية في الشرق الأوسط.",
      tagline: "شريكك للأنظمة الهندسية",
    },
    home: {
      overviewLabel: "نبذة عن الشركة",
      overviewTitle: "شركة هندسية مقرها دبي، متخصصة في القطاع الصناعي بالشرق الأوسط.",
      overviewBody:
        "مسجّلة ضمن منطقة IFZA في الإمارات، وتعمل في العراق ومصر والشرق الأوسط، تتعاون ويفز تكنولوجي مع كبار المصنّعين الدوليين لتقديم أنظمة هندسية وحلول توريد واستشارات فنية وتطوير مشاريع لقطاعات النفط والغاز والمياه والبنية التحتية.",
      servicesLabel: "قدراتنا الأساسية",
      servicesTitle: "من المفهوم والهندسة إلى التوريد والتنفيذ والتشغيل.",
      industriesLabel: "القطاعات التي نخدمها",
      industriesTitle: "القطاعات التي نخدمها",
      lifecycleLabel: "دعم دورة حياة المشروع",
      lifecycleTitle: "شريك موثوق",
      lifecycleBody:
        "يساعدنا انخراطنا المبكر في تقليل المخاطر التقنية وتنسيق المورّدين ووضع الميزانية، ويمنح مقاولي EPC والمالكين شريكاً هندسياً موحّداً.",
      partnersLabel: "مصنّعون دوليون",
      partnersTitle: "ثقة شركاء التكنولوجيا الدوليين وعملاء EPC.",
      whyLabel: "لماذا ويفز تكنولوجي",
      whyTitle: "عمق هندسي. حضور إقليمي. شبكة توريد عالمية.",
      ctaTitle: "يسعدنا خدمتكم",
      ctaBody: "أرسل طلب عرض السعر أو تحدث مع فريقنا الهندسي عن مشروعك القادم.",
    },
    services: {
      title: "المنتجات والخدمات",
      subtitle: "أنظمة هندسية، توريد، استشارات ودعم دورة حياة المشاريع الصناعية والبنية التحتية.",
    },
    industries: {
      title: "القطاعات التي نخدمها",
      subtitle: "أنظمة هندسية وتوريد للقطاعات التي تقود الاقتصاد الصناعي في المنطقة.",
    },
    partners: {
      title: "الشركاء والموردون",
      subtitle: "شبكة منتقاة من المصنّعين الدوليين وموردي التكنولوجيا.",
    },
    projects: {
      title: "المشاريع والمراجع",
      subtitle: "عيّنة من أعمال الهندسة والتوريد وتطوير المشاريع في العراق ومصر والإمارات.",
    },
    rfq: {
      title: "طلب عرض سعر",
      subtitle: "شاركنا متطلبات مشروعك وأرفق الرسومات أو ورقات البيانات أو جداول الكميات.",
      companyName: "اسم الشركة",
      contactPerson: "الشخص المسؤول",
      email: "البريد الإلكتروني للأعمال",
      phone: "الهاتف (مع رمز الدولة)",
      country: "الدولة",
      category: "فئة المنتج / الخدمة",
      description: "وصف المشروع / طلب عرض السعر",
      attachment: "مرفق (PDF / XLSX / ZIP، حتى 10 ميجابايت)",
      attachmentHint: "اسحب الملف هنا أو انقر للاختيار",
      categoryPlaceholder: "اختر فئة",
    },
    contact: {
      title: "تواصل مع ويفز تكنولوجي",
      subtitle: "تحدث مع فريق الهندسة والتوريد للتقييم الفني وطلبات عروض الأسعار.",
      formTitle: "أرسل لنا رسالة",
      name: "الاسم",
      company: "الشركة",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      country: "الدولة",
      subject: "الموضوع",
      message: "الرسالة",
      officeTitle: "المكتب الرئيسي",
      officeAddress: "واحة دبي للسيليكون، DDP، المبنى A1، دبي، الإمارات",
      emailLabel: "البريد الإلكتروني",
      websiteLabel: "الموقع",
      hoursLabel: "ساعات العمل",
      hours: "الأحد – الخميس · 09:00 – 18:00 (بتوقيت الخليج)",
    },
    about: {
      title: "عن ويفز تكنولوجي",
      subtitle: "شركة هندسية تجمع بين المصنّعين الدوليين والأنظمة الهندسية والتنفيذ الإقليمي.",
      backgroundLabel: "نبذة عن الشركة",
      visionLabel: "الرؤية",
      missionLabel: "الرسالة",
      valuesLabel: "قيمنا",
    },
    footer: {
      tagline: "شريكك للأنظمة الهندسية",
      quickLinks: "روابط سريعة",
      capabilities: "القدرات",
      contact: "تواصل",
      rights: "جميع الحقوق محفوظة.",
      registered: "مسجلة لدى IFZA، دبي، الإمارات",
    },
  },
};
